import { httpServices } from '../../../apis'
import type { QueryFnParams } from '../../../types'

import type { CollectiveAgreementSchema } from './types/account.collectiveAgreements.schema'

export type FetchOneOption = QueryFnParams<{
  pathParams: {
    ccn_id: number
  }
}>

export const fetchOne = async (options: FetchOneOption) => {
  const response = await httpServices.core.get<CollectiveAgreementSchema>(
    `/employee_management/collective_agreements/${options.pathParams.ccn_id}`,
    {
      params: {
        includes: ['classification', 'rules']
      }
    }
  )

  return response.data
}
